import React, { useState } from "react";
import { TextInput } from "../indexComponents";

function ClientForm({ onClientAdded, close }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [website, setWebsite] = useState("");
  const [errorMessage, setErrorMessage] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (name.trim() === "" && company.trim() === "") {
      setErrorMessage(
        "Vous devez entrer au minimum le nom du client ou de son entreprise."
      );
      setTimeout(() => {
        setErrorMessage();
      }, 3500);
      return;
    }

    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_API_URL}/clients`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ name, email, company, phoneNumber, website }),
    });

    if (response.ok) {
      onClientAdded();
      setName("");
      setEmail("");
      setCompany("");
      setPhoneNumber("");
      setWebsite("");
    } else {
      console.error("Erreur lors de l'ajout du client");
    }
  };

  return (
    <form className="clientForm" onSubmit={handleSubmit}>
      <button onClick={close}>Fermer</button>
      {errorMessage ? <p className="error-message">{errorMessage}</p> : ""}
      <div className="row">
        <TextInput
          labelText="Nom du client"
          name="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextInput
          labelText="Email du client"
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className="row">
        <TextInput
          labelText="Compagnie du client :"
          name="company"
          type="text"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
        />
        <TextInput
          labelText="Numéro de téléphone du client :"
          name="phoneNumber"
          type="tel"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
      </div>
      <TextInput
        labelText="Site web du client :"
        name="website"
        type="text"
        value={website}
        onChange={(e) => setWebsite(e.target.value)}
      />
      <button type="submit">Ajouter un client</button>
    </form>
  );
}

export default ClientForm;
